/* Retag theme fixes – Oct 2026. Loaded from snippets/halo-banner-adv-left.liquid */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Blog article: mobile "Explore" drawer ---------- */
  function initArticleDrawer() {
    var article = document.querySelector('.rt-article');
    if (!article) return;
    var openBtn = article.querySelector('[data-rt-drawer-open]');
    var overlay = article.querySelector('.rt-article__drawer-overlay');

    function setOpen(open) {
      article.classList.toggle('is-drawer-open', open);
      document.body.classList.toggle('rt-drawer-lock', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (overlay) overlay.hidden = !open;
    }
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    article.querySelectorAll('[data-rt-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 860) setOpen(false); });
  }

  /* ---------- Blog article: copy link ---------- */
  function initCopyLinks() {
    document.querySelectorAll('[data-rt-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-rt-copy');
        var done = function () {
          var tip = btn.querySelector('.rt-share__copied');
          if (!tip) return;
          tip.hidden = false;
          setTimeout(function () { tip.hidden = true; }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else {
          var t = document.createElement('textarea');
          t.value = url; document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t); done();
        }
      });
    });
  }

  /* ---------- Blog article: bold-only paragraphs become headings ---------- */
  function initArticleHeadings() {
    var body = document.querySelector('[data-rt-article-body]');
    if (!body) return;
    var paras = Array.prototype.slice.call(body.querySelectorAll(':scope > p'));
    paras.forEach(function (p) {
      if (p.querySelector('img, a, iframe')) return;
      var kids = Array.prototype.filter.call(p.children, function (el) {
        return el.textContent.trim() !== '';
      });
      if (kids.length !== 1) return;
      var k = kids[0];
      var isBold = /^(STRONG|B)$/.test(k.tagName) || (k.querySelector && k.querySelector('strong, b') &&
        k.querySelector('strong, b').textContent.trim() === k.textContent.trim());
      if (!isBold) return;
      var text = p.textContent.trim();
      if (!text || text !== k.textContent.trim() || text.length > 120) return;
      var prev = p.previousElementSibling;
      var prevIsHeading = prev && prev.classList.contains('rt-h2');
      var level = prevIsHeading ? 'h3' : 'h2';
      var h = document.createElement(level);
      h.className = level === 'h2' ? 'rt-h2' : 'rt-h3';
      h.textContent = text.replace(/:$/, '');
      p.replaceWith(h);
    });
  }

  ready(function () {
    initArticleDrawer();
    initCopyLinks();
    initArticleHeadings();
  });
})();
